module.exports = __webpack_public_path__ + "media/images/default_banner_4-0ffc87b93e6167101ba4e757b5f4523c.webp";